import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IFilter } from "./Filter";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { Button } from "primereact/button";

export interface IMassMailHistory {
  history_ID?: number;
  email_To_Name?: string;
  email_To_Email?: string;
  vendor_Company_Name?: string;
  requested_By?: string;
  requested_By_Branch?: string;
  requested_By_Company?: string;
  requested_On?: string;
  requested_Status?: number;
  requested_Email_Status?: number;
  email_Body?: string;
  no_Of_Emails?: number;
  email_Subject?: string,
  email_CC?: string,
  to_Self?: boolean,
  no_Of_Emails_Pending?: number,
  no_Of_Emails_Sent?: number,
  no_Of_Emails_Failed?: number,
}

interface IProps {
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
  tableData: IMassMailHistory[];
  setTableData: React.Dispatch<React.SetStateAction<IMassMailHistory[]>>;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
  onOpenMail: (row: IMassMailHistory) => void;
  openDetail: (row: IMassMailHistory) => void;
}

export const Table = (props: IProps) => {
  const dt = useRef<any>(null);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState<IFilter>(EmptyFilter);

  const loadData = async () => {
    setLoading(true);

    // const response = await Fetch("MassMail/sentMassMailHistory", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast,);
    const response = await Fetch("MassMail/sentMassMailSummary", "GET", null, `filters=${JSON.stringify(filters)}`, props.toast,);

    if (response) {
      const data = await response.json();
      props.setTableData(data);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [filters, props.reload]);

  const emailBody = (row: IMassMailHistory) => {
    return (
      <span
        className="p-link"
        style={{ fontWeight: 600, color: "#14A4E0" }}
        onClick={() => props.onOpenMail(row)}
      >
        View
        <i className="pi pi-eye" style={{ marginLeft: 6 }} />
      </span>
    );
  };



  const openEmailCount = (row: IMassMailHistory) => {
    props.openDetail(row);
  };
  const noOfEmail = (row: IMassMailHistory) => (
    <span
      style={{
        color: "#0d6efd",
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 600
      }}

      onClick={() => openEmailCount(row)}
    >

      {row.no_Of_Emails}
    </span>
  )
  const StatusTemplate = (row: IMassMailHistory) => {
    //return row.requested_Status === 1 ? <p style={{ color: "black", backgroundColor: "#fcf951", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, }}>Pending</p> : (row.requested_Status === 2 ? <p style={{ color: "white", backgroundColor: "#155724", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, }}>Sent</p> : <p style={{ color: "white", backgroundColor: "#721c24", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, }}>Failed</p>);

    return (
      <div className="flex gap-2">
        <Button tooltip="Pending" className="border-none" tooltipOptions={{ position: "top" }} style={{ color: "black", backgroundColor: "#fcf951", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, height: "2rem" }}>{row.no_Of_Emails_Pending}</Button>
        <Button tooltip="Sent" className="border-none" tooltipOptions={{ position: "top" }} style={{ color: "white", backgroundColor: "#155724", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, height: "2rem" }}>{row.no_Of_Emails_Sent}</Button>
        <Button tooltip="Failed" className="border-none" tooltipOptions={{ position: "top" }} style={{ color: "white", backgroundColor: "#721c24", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, height: "2rem" }}>{row.no_Of_Emails_Failed}</Button>
      </div>
    );
  }

  // const EmailStatusTemplate = (row: IMassMailHistory) => {
  //   return row.requested_Email_Status === 1 ? <p style={{ color: "black", backgroundColor: "#fcf951", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, }}>Pending</p> : (row.requested_Email_Status === 2 ? <p style={{ color: "white", backgroundColor: "#155724", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, }}>Sent</p> : <p style={{ color: "white", backgroundColor: "#721c24", padding: "5px 10px", borderRadius: "20px", fontWeight: 600, }}>Failed</p>);
  // }


  // const dateTemplate = (row: IMassMailHistory) => row.requested_On ? new Date(row.requested_On).toLocaleString() : "";


  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
  const DateFormat = loginObj.date_Format;
  return (
    <>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={setFilters} />
        </AccordionTab>
      </Accordion>

      <DataTable ref={dt} value={props.tableData} loading={loading} size="small"
        showGridlines stripedRows responsiveLayout="scroll" emptyMessage="No History Found"
      >
        <Column header="SN" body={(rowData, options) => options.rowIndex + 1} />
        {/* <Column field="email_To_Name" header="Name" /> */}
        {/* <Column field="email_To_Email" header="Email" /> */}
        {/* <Column field="vendor_Company_Name" header="Vendor Company" /> */}
        <Column field="requested_By" header="Requested By" />
        <Column field="company_Name" header="Company" />
        <Column field="branch_Name" header="Branch" />
        <Column header="Requested On" body={(rowData: any) => safeFormatDate(rowData.requested_On, 'dd/MM/yyyy', DateFormat, true)}
        />
        <Column header="Email Body" body={emailBody} />
        <Column header="No Of Email" body={noOfEmail} />
        <Column header="Request Status" body={(rowData: any) => StatusTemplate(rowData)} />
        {/* <Column header="Email Status" body={(rowData: any) => EmailStatusTemplate(rowData)} /> */}
      </DataTable>
    </>
  );
};

export default Table;
